import { render, staticRenderFns } from "./CourseStudyTotalsDetails.vue?vue&type=template&id=4758cd53&scoped=true"
import script from "./CourseStudyTotalsDetails.vue?vue&type=script&lang=js"
export * from "./CourseStudyTotalsDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseStudyTotalsDetails.vue?vue&type=style&index=0&id=4758cd53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4758cd53",
  null
  
)

export default component.exports